<template>
  <v-container class>
    <v-row>
      <v-col cols="4">
        <v-card class="st-app">
          <v-card-title class="f-14">
            <v-row>
              <v-col>Group Akses</v-col>
              <v-col>
                <v-btn color="primary" class="float-right" small @click="addDialogGroup">
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
          <v-divider></v-divider>
          <v-list rounded>
            <v-list-item-group v-model="selectedMenu" color="primary" class="sae child-link">
              <v-list-item v-for="(item, i) in groupList" :key="i">
                <v-list-item-icon class="mr-1"></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="capitalize" v-text="item.name"></v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon class="mr-1">
                  <v-btn
                    icon
                    @click="editItemGroup(item)"
                    small
                    v-bind:class="[selectedMenu == i ? 'white--text' :'']"
                    class="z-top"
                  >
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                </v-list-item-icon>
                <v-list-item-icon class="mr-1">
                  <v-btn
                    icon
                    @click="deleteItem(item, true)"
                    small
                    v-bind:class="[selectedMenu == i ? 'white--text' :'']"
                    class="z-top"
                  >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </v-list-item-icon>
              </v-list-item>
            </v-list-item-group>
          </v-list>
          <!-- <v-list rounded>
            <v-list-item-group color="primary" class="sae child-link" v-model="selectedMenu">
              <v-list-item v-for="(item, i) in groupList" :key="i">
                <v-list-item-icon class="mr-1"></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="capitalize" v-text="item.name"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>-->
        </v-card>
      </v-col>
      <v-col v-show="tableCondition" cols="8">
        <v-card class="rounded-br-0 rounded-bl-0">
          <v-card-text>
            <v-data-table
              class="tf-14"
              :loading="loading"
              :headers="headers"
              :items="items"
              :no-data-text="$t('no_data')"
              :footer-props="{ 'items-per-page-options': [10, 50, 100] }"
              hide-default-footer
            >
             <template v-slot:footer.page-text="items"> {{ items.pageStart }} - {{ items.pageStop }} {{$t('of')}} {{ items.itemsLength }} </template>
              <template v-slot:item.action="{item}">
                <!-- <v-btn icon color="primary" @click="editItem(item)">Fem
                  <v-icon small>mdi-pencil</v-icon>
                </v-btn>-->
                <v-btn icon color="error" @click="deleteItem(item)">
                  <v-icon small>mdi-delete</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
        <v-card dark color="primary" class="rounded-tr-0 rounded-tl-0 cursor" @click="addDialog">
          <v-card-text>
            <v-icon class="mr-2">mdi-plus</v-icon>
            <span class="bold">Add User</span>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog overlay-opacity="0.7" v-model="dialogGroup" max-width="550">
      <v-form v-model="valid" ref="form">
        <v-card>
          <v-card-title class="headline">{{isEdit ? 'Edit' :'Add'}} Group Akses</v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  label="Name"
                  v-model="detail.name"
                  type="text"
                  :rules="rules"
                  required
                  class="sae-required"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field label="Note" v-model="detail.note" type="text"></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="pa-3">
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              @click="saveOrUpdateGroup(detail)"
              :loading="loading"
              :disabled="!valid"
            >Save</v-btn>
            <v-btn color="default" text @click="dialogGroup = false">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <v-dialog overlay-opacity="0.7" v-model="dialog" max-width="550">
      <v-form v-model="valid" ref="form">
        <v-card>
          <v-card-title class="headline">{{isEdit ? 'Edit' :'Add'}} User Access</v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-autocomplete
                  label="Set Specific permissisons for members"
                  :items="userList"
                  v-model="detail.userId"
                  item-text="full_name"
                  item-value="id"
                  :rules="rules"
                  :filter="filter"
                  required
                  class="sae-required"
                >
                  <template
                    slot="selection"
                    slot-scope="{ item }"
                  >
                  <div class="elipsis mt-2">
                    {{item.full_name}} • {{item.email}}
                  </div>
                  </template>
                  <template slot="item" slot-scope="{ item }">
                    <p>{{item.full_name}} • {{item.email}}</p>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="12">
                <v-autocomplete
                  label="Set Level Security User"
                  :items="levelAccess"
                  v-model="detail.levelAccessId"
                  item-text="name"
                  item-value="id"
                  :rules="rules2"
                  required
                  class="sae-required"
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="pa-3">
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              @click="saveOrUpdate(detail)"
              :loading="loading"
              :disabled="!valid"
            >Save</v-btn>
            <v-btn color="default" text @click="dialog = false">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <v-dialog overlay-opacity="0.7" v-model="deleteDialog" max-width="290">
      <v-card>
        <v-card-title class="headline">Delete!</v-card-title>
        <v-card-text>Are you sure you would like to do this?</v-card-text>
        <v-card-actions class="pa-3">
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="deleteDialog = false">Cancel</v-btn>
          <v-btn color="error" :loading="loading" @click="deleteProcess(itemToDelete)">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
export default {
  name: "UserSetting",
  data() {
    return {
      isDeleteGroup: false,
      companyId: this.$store.getters.pGetData('companyId'),
      rules: [(value) => (value === 0 ? true : !!value || this.$i18n.t('required'))],
      rules2: [(value) => (value == 0 ? true : value ? value > 0 : !!value || this.$i18n.t('required'))],
      valid: false,
      dialog: false,
      dialogGroup: false,
      deleteDialog: false,
      tableCondition: false,
      itemToDelete: {},
      selectedMenu: null,
      loading: false,
      detail: {
        userId: null,
        levelAccessId: null,
      },
      isEdit: false,
      headers: [
        { text: "Email", value: "email" },
        { text: "Level", value: "levelAccessName" },
        { text: "Aksi", value: "action" },
      ],
      items: [],
      groupList: [],
      userList: [],
      levelAccess: [],
    };
  },
  methods: {
    filter(item, queryText) {
      return (
        item.full_name.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1 ||
        item.email.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1
      )
    },
    addDialog() {
      this.isEdit = false
      this.dialog = true
    },
    addDialogGroup() {
      this.isEdit = false
      this.dialogGroup = true
    },
    showMessage(type, msg) {
      this.$store.dispatch('nShowMessage', { type, msg })
    },
    editItem(item) {
      this.detail = Object.assign({}, item)
      this.isEdit = true
      this.dialog = true
    },
    editItemGroup(item) {
      this.detail = Object.assign({}, item)
      this.isEdit = true
      this.dialogGroup = true
    },
    deleteItem(item, isGroup = false) {
      this.itemToDelete = Object.assign({}, item);
      this.deleteDialog = true;
      this.isDeleteGroup = isGroup
    },
    async getGroupAccess() {
      this.loading = true
      const result = await this.$store.dispatch('getGroupAccess', { companyId: this.companyId })
      this.loading = false
      return result
    },
    async getUserAccess(groupAccessId) {
      this.loading = true
      const result = await this.$store.dispatch('getUserAccess', { groupAccessId, companyId: this.companyId })
      this.loading = false
      return result
    },
    async getLevelAccess() {
      this.loading = true
      const result = await this.$store.dispatch('getLevelAccess', { companyId: this.companyId })
      this.loading = false
      return result
    },
    async getUsers() {
      this.loading = true
      const result = await this.$store.dispatch('getEmployeeListNoPagination', { companyId: this.companyId })
      this.loading = false
      return result.rows
    },
    async saveOrUpdate(data) {
      if (this.isEdit) {
        this.editComponent(data)
      } else {
        this.saveComponent(data)
      }
    },
    async saveComponent(data) {
      const body = { ...data, groupAccessId: this.groupList[this.selectedMenu].id, companyId: this.companyId }
      this.loading = true
      const result = await this.$store.dispatch('saveUserAccess', body)
      this.loading = false
      if (result) {
        this.showMessage('success', this.$i18n.t('alert_save'))
        this.dialog = false
        this.refreshData(this.selectedMenu)
      }
    },
    async editComponent(data) {
      const body = { ...data, groupAccessId: this.groupList[this.selectedMenu].id, companyId: this.companyId }
      this.loading = true
      const result = await this.$store.dispatch('editUserAccess', body)
      this.loading = false
      if (result) {
        this.showMessage('success', this.$i18n.t('alert_save'))
        this.dialog = false
        this.refreshData(this.selectedMenu)
      }
    },
    async deleteUserAccess(data) {
      this.loading = true
      const result = await this.$store.dispatch('deleteUserAccess', { id: data.id, companyId: this.companyId })
      this.loading = false
      if (result) {
        this.showMessage('success', 'Delete Success!')
        this.deleteDialog = false
        this.refreshData(this.selectedMenu)
      }
    },

    async saveOrUpdateGroup(data) {
      if (this.isEdit) {
        this.editComponentGroup(data)
      } else {
        this.saveComponentGroup(data)
      }
    },

    async saveComponentGroup(data) {
      const body = { ...data, companyId: this.companyId }
      this.loading = true
      const result = await this.$store.dispatch('saveGroupAccess', body)
      this.loading = false
      if (result) {
        this.showMessage('success', this.$i18n.t('alert_save'))
        this.dialogGroup = false
        this.refreshDataGroup()
      }
    },
    async editComponentGroup(data) {
      const body = { ...data, companyId: this.companyId }
      this.loading = true
      const result = await this.$store.dispatch('editGroupAccess', body)
      this.loading = false
      if (result) {
        this.showMessage('success', this.$i18n.t('alert_save'))
        this.dialogGroup = false
        this.refreshDataGroup()
      }
    },
    async deleteGroupAccess(data) {
      this.loading = true
      const result = await this.$store.dispatch('deleteGroupAccess', { id: data.id, companyId: this.companyId })
      this.loading = false
      if (result) {
        this.showMessage('success', 'Delete Success!')
        this.deleteDialog = false
        this.refreshDataGroup()
      }
    },
    async deleteProcess() {
      if (this.isDeleteGroup) {
        this.deleteGroupAccess(this.itemToDelete)
      } else {
        this.deleteUserAccess(this.itemToDelete)
      }
    },
    async refreshDataGroup() {
      this.groupList = await this.getGroupAccess()
    },
    async refreshData(index) {
      this.items = await this.getUserAccess(this.groupList[index].id)
      this.tableCondition = true
      
    },
  },
  async created() {
    this.groupList = await this.getGroupAccess()
    if (this.groupList.length > 0) {
      this.refreshData(0)
      this.selectedMenu = 0
    }
    this.userList = await this.getUsers()
    this.levelAccess = await this.getLevelAccess()
  },
  watch: {
    async selectedMenu(id) {
      if (id != null) {
        this.refreshData(id)
      }else {
        this.items = []
        this.tableCondition = false
      }
    },
    dialog(bool) {
      if (this.$refs.form && !this.isEdit && bool == false) {
        this.$refs.form.reset();
      }
    },
    dialogGroup(bool) {
      if (this.$refs.form && !this.isEdit && bool == false) {
        this.$refs.form.reset();
      }
    }
  }
};
</script>
<style scoped>
.elipsis {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>